import { useContext } from 'react';
import AppContext from '../AppContext';
import Artikelinfo from './right/Artikelinfo';
import ArtikelInWarenkorb from './right/ArtikelInWarenkorb';
import Artikelpreis from './right/Artikelpreis';
import Artikelzusatz from './right/Artikelzusatz';
import Card from './common/Card';
import Konfiguration from './right/Konfiguration';
import Rolladenmass from './left/Rolladenmass';
import Laengenmass from './left/Laengenmass';
import Variation from './left/Variation';
import './View.scss';
import Hochwasserschutz from './left/Hochwasserschutz';
import Insektenschutz from './left/Insektenschutz';

function View() {
  const { appData } = useContext(AppContext);
  return (
    <div className="configurator__view product-detail" id="product-offer">
      <div className="d-flex flex-row flex-wrap gap-3">
        <div className="variations d-flex flex-column gap-2">
          {appData.static.config.productType === 'rolladen'
            && (
              <Rolladenmass />
            )}
          {(appData.static.config.productType === 'stahlwelle'
            || appData.static.config.productType === 'lamelle'
            || appData.static.config.productType === 'fuehrungsschiene'
            || appData.static.config.productType === 'endleiste'
            || appData.static.config.productType === 'deckleiste')
            && (
              <Laengenmass />
            )}
          {appData.static.config.productType === 'hochwasserschutz'
            && (
              <Hochwasserschutz />
            )}
          {appData.static.config.productType === 'insektenschutz'
            && (
              <Insektenschutz />
            )}
          {appData.static.config.productType !== 'hochwasserschutz'
            && Object.values(appData.static.artikel.variationen).map((variation) => (
              variation.kEigenschaft !== appData.static.kEigenschaftBreite
              && variation.kEigenschaft !== appData.static.kEigenschaftHoehe
              && variation.kEigenschaft !== appData.static.kEigenschaftLaenge
              && variation.kEigenschaft !== appData.static.kEigenschaftTiefe
              && (
                <Card key={variation.kEigenschaft}>
                  <Variation kEigenschaft={variation.kEigenschaft} withoutPrice={false} />
                </Card>
              )))}
        </div>
        <div className="info-buy product-info">
          <div className="sticky-container d-flex flex-column gap-5">
            <Artikelinfo />
            <div className="d-flex flex-column product-offer">
              <Konfiguration />
              <Artikelpreis />
              <Artikelzusatz />
              <ArtikelInWarenkorb />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default View;
